<template>
  <div class="widget-error" :class="{ compact }">
    <Icon icon="rocket-crashed" />
    <h3>{{ $t(heading) }}</h3>
    <p class="text-grey">{{ $t(description) }}</p>
    <button
      v-if="!hideRetry"
      class="link link-main icon-link"
      @click="$emit('retry')"
    >
      <Icon icon="refresh" />
      {{ $t(retryLabel) }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'WidgetError',
  props: {
    heading: {
      type: String,
      default: 'GENERAL.ERROR.HEADING',
    },
    description: {
      type: String,
      default: 'GENERAL.ERROR.TEXT1',
    },
    retryLabel: {
      type: String,
      default: 'GENERAL.RETRY',
    },
    hideRetry: {
      type: Boolean,
    },
    compact: {
      type: Boolean,
    },
  },
  emits: ['retry'],
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.widget-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;

  & > .icon {
    width: 5em;
    height: 5em;
    margin-bottom: 19px;
    color: $pa-color-red;
  }

  h3 {
    margin: 0 0 12px 0;
  }

  p {
    margin-bottom: 0;
  }

  button {
    margin-top: 12px;
    padding: 12px 8px;
  }

  &.compact {
    padding: 16px 0;
    align-items: flex-start;
    text-align: left;

    & > .icon {
      width: 2em;
      height: 2em;
      margin-bottom: 8px;
    }

    h3 {
      margin-bottom: 4px;
      font-size: 16px;
    }

    button {
      margin-top: 4px;
      padding: 4px 0;
    }
  }
}
</style>
